export var ModalActions;
(function (ModalActions) {
    ModalActions["CANCEL"] = "CANCEL";
    ModalActions["OK"] = "OK";
    ModalActions["OUTSIDE_CLICKED"] = "OUTSIDE_CLICKED";
})(ModalActions || (ModalActions = {}));
